import React from 'react';
import { Link } from 'react-router-dom';
import {
  COMPARE_HUB_DOCUMENT_TITLE,
  COMPARE_HUB_META_DESCRIPTION,
  COMPARE_HUB_PATH,
  COMPARISON_PAGES,
  getComparisonProducts,
} from '../comparisons/comparisonConfigs';
import { usePageSeo } from '../../seo/usePageSeo';
import EarlyAccessCallout from '../earlyAccess/EarlyAccessCallout';
import './CompareHubPage.css';

export default function CompareHubPage() {
  usePageSeo({
    title: COMPARE_HUB_DOCUMENT_TITLE,
    description: COMPARE_HUB_META_DESCRIPTION,
    path: COMPARE_HUB_PATH,
  });

  return (
    <div className="ab-compare" data-testid="compare-hub">
      <header className="ab-compare-hero">
        <p className="ab-compare-kicker">Compare Garmin Options</p>
        <h1 className="ab-compare-title">Compare Garmin LiveScope Options</h1>
        <p className="ab-compare-lede">
          See the differences that matter, then choose the comparison that
          matches what you're deciding.
        </p>
      </header>

      <section
        className="ab-compare-list"
        aria-labelledby="compare-available-heading"
      >
        <h2 id="compare-available-heading" className="ab-compare-list-title">
          Available comparison
        </h2>
        <ul className="ab-compare-items">
          {COMPARISON_PAGES.map((page) => {
            const products = getComparisonProducts(page);
            return (
              <li key={page.id}>
                <article
                  className="ab-compare-item"
                  data-testid={`compare-hub-item-${page.id}`}
                >
                  <div
                    className="ab-compare-item-visual"
                    data-count={products.length}
                    aria-hidden="true"
                  >
                    {products.map((product) => (
                      <figure key={product.key}>
                        <img
                          src={product.imageFallback}
                          alt=""
                        />
                        <figcaption>{product.shortLabel}</figcaption>
                      </figure>
                    ))}
                  </div>
                  <div className="ab-compare-item-copy">
                    <h3 className="ab-compare-item-title">{page.hubTitle}</h3>
                    <p className="ab-compare-item-models">{page.modelLine}</p>
                    <p className="ab-compare-item-summary">{page.hubSummary}</p>
                    <Link
                      className="ab-compare-item-cta"
                      to={page.path}
                      data-testid={`compare-hub-cta-${page.id}`}
                    >
                      {page.hubCta || 'View comparison'}
                    </Link>
                  </div>
                </article>
              </li>
            );
          })}
        </ul>
      </section>
      <EarlyAccessCallout page="compare" placement="compare_hub" />
    </div>
  );
}
